import { component } from 'picoapp'
import Tabs from '../lib/tabs'
import $ from 'quantdom'

export default component((node) => {
  const benefitTabContainer = $(node).find('[data-benefit-tabs]')
  const headers = $(node).find('button[data-tab-header]')
  const tabs = new Tabs({ el: benefitTabContainer.el() }, () => {})

  headers.each((header) => {
    $(header).on('click', (e) => {
      const newTabPanel = $(node)
        .find(`#${e.target.getAttribute('aria-controls')}`)
        .el()
      tabs.setActiveTab(header, newTabPanel)
    })
  })
})
